const mapDefinition = (definition) => {
  let result = {
    isDefault: definition.isDefault,
    page: definition.component,
  };
  switch (typeof definition.route) {
    case 'string':
      result = {
        ...result,
        path: definition.route,
      };
      break;
    case 'object':
      result = {
        ...result,
        ...definition.route,
      };
      break;
    default:
      result = {
        ...result,
        ...definition,
      };
      break;
  }

  return result;
};

export const groupRouteMaps = (routesDefinition) =>
  Object.entries(routesDefinition).reduce(
    (group, [routeName, definition]) => ({
      ...group,
      routes: {
        ...group.routes,
        [routeName]: mapDefinition(definition),
      },
    }),
    { routes: {}, components: {} },
  );

export const getDefaultPage = (routesMap) => {
  let defaultPage = 'Index';

  if (Object.keys(routesMap).length > 0) {
    const defaultRoutes = Object.values(routesMap).filter((definition) => definition.isDefault);

    if (defaultRoutes.length !== 1) {
      throw new Error('You must define ONE default route');
    }

    const defaultRoute = defaultRoutes[0];

    defaultPage = defaultRoute.component || defaultRoute.page;
  }
  return defaultPage;
};
